import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconStravaStyle0 = gravityIconIndividualCss;

const GravityIconStrava = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '4957e287e68a588bb2f5270bb4af412482a12342', color: this.color, size: this.size }, h("svg", { key: '27f44bdacdb8ccc7dadbeef7f0e02d9b90e85206', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '5e3f0dc29e1a6b68d2670cd58291dcfc25fccbe5', d: "m12.449 12.445-2.243-4.427-2.238 4.428H4.672l5.534-10.934 5.541 10.933h-3.298Zm-.002.001 1.652 3.254 1.647-3.254h2.426l-4.073 8.042-4.075-8.042h2.423Z", fill: "currentColor" }))));
    }
};
GravityIconStrava.style = GravityIconStravaStyle0;

export { GravityIconStrava as gravity_icon_strava };

//# sourceMappingURL=gravity-icon-strava.entry.js.map